import { useReducer, useMemo } from 'react';

export interface ModalState {
  isAnalystsModalOpen: boolean;
  isValuationModalOpen: boolean;
  isFairValueModalOpen: boolean;
}

interface Action {
  type: 'TOGGLE_ANALYSTS' | 'TOGGLE_VALUATION' | 'TOGGLE_FAIR_VALUE';
}

export const initialModalState: ModalState = {
  isAnalystsModalOpen: false,
  isValuationModalOpen: false,
  isFairValueModalOpen: false,
};

function toggleReducer(state: ModalState, action: Action): ModalState {
  switch (action.type) {
    case 'TOGGLE_ANALYSTS':
      return { ...state, isAnalystsModalOpen: !state.isAnalystsModalOpen };
    case 'TOGGLE_VALUATION':
      return { ...state, isValuationModalOpen: !state.isValuationModalOpen };
    case 'TOGGLE_FAIR_VALUE':
      return { ...state, isFairValueModalOpen: !state.isFairValueModalOpen };
    default:
      throw new Error(`Unhandled type: ${action.type}`);
  }
}

export function useFairValueModals() {
  const [state, dispatch] = useReducer(toggleReducer, { ...initialModalState });

  return useMemo(() => {
    const toggleAnalystsModal = () => {
      dispatch({ type: 'TOGGLE_ANALYSTS' });
    };

    const toggleValuationModal = () => {
      dispatch({ type: 'TOGGLE_VALUATION' });
    };

    const toggleFairValueModal = () => {
      dispatch({ type: 'TOGGLE_FAIR_VALUE' });
    };

    return {
      state,
      actions: {
        toggleAnalystsModal,
        toggleValuationModal,
        toggleFairValueModal,
      },
    };
  }, [state, dispatch]);
}
